import { render, staticRenderFns } from "./MatchLocked.vue?vue&type=template&id=52a17b7a&scoped=true"
import script from "./MatchLocked.vue?vue&type=script&lang=js"
export * from "./MatchLocked.vue?vue&type=script&lang=js"
import style0 from "./MatchLocked.vue?vue&type=style&index=0&id=52a17b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a17b7a",
  null
  
)

export default component.exports